import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { useHistory, useParams } from 'react-router-dom';

import AlbumPurchasedCustomPrintDetailsContainer from './AlbumPurchasedCustomPrintDetailsContainer';
import { getProductBasenames } from '../../../../../../util/role-definitions';
import ProLayout from '../../../../components/ProLayout';
import AlbumInnerPageHeader from '../../AlbumInnerPageHeader';
import AlbumFolderInnerPageHeader from '../../../AlbumFolder/AlbumFolders/AlbumFolderInnerPageHeader';
import TransactionDetailsModal from '../../../../../../components/product/TransactionDetailsModal';

const propTypes = {
  basename: PropTypes.oneOf(getProductBasenames()).isRequired,
};

const AlbumPurchasedCustomPrintDetailsView = ({ basename }) => {
  const { albumId, albumFolderId } = useParams();
  const history = useHistory();

  return (
    <Fragment>
      <Helmet>
        <title>Album Custom Prints</title>
      </Helmet>

      <ProLayout.Main>
        <ProLayout.MainContent>
          <AlbumInnerPageHeader
            title="Print Order Details"
            backButtonProps={{
              onClick: async event => {
                event.preventDefault();
                history.push(`/app/${basename}/albums/${albumId}/orders`);
              },
            }}
          />
          <AlbumFolderInnerPageHeader
            title="Print Order Details"
            backButtonProps={{
              onClick: async event => {
                event.preventDefault();
                history.push(
                  `/app/${basename}/folders/${albumFolderId}/orders`,
                );
              },
            }}
          />
          <AlbumPurchasedCustomPrintDetailsContainer basename={basename} />
          <TransactionDetailsModal />
        </ProLayout.MainContent>
      </ProLayout.Main>
    </Fragment>
  );
};

AlbumPurchasedCustomPrintDetailsView.propTypes = propTypes;

export default AlbumPurchasedCustomPrintDetailsView;
